import React from 'react';
import { useSelector } from 'react-redux';
import NoResultsErrorPage from 'component/page/search/Error/NoResultsErrorPage';
import { selectTextForTextSearch } from 'store/slice/home';
import { selectFilteredActivitiesFromSearchState, selectFilterState, selectSearchState, selectTotalActivitiesFromSearchState } from 'component/page/search/store/search.selectors';

const SearchSupplyError: React.FC = (props) => {
    const cityName = useSelector(selectTextForTextSearch);
    const state = useSelector(selectSearchState);
    const totalActivities = useSelector(selectTotalActivitiesFromSearchState);
    const filteredActivities = useSelector(selectFilteredActivitiesFromSearchState);
    const selectedFilters = useSelector(selectFilterState);

    const errorMessage = (state.error?.message || '').toLowerCase();
    const isSupplyError = state.isError && state.error && errorMessage.includes('activity supply searcherror');
    const isEmptyActivities = state.isSuccess && totalActivities === 0;
    const isEmptyFromFiltered = state.isSuccess && totalActivities > 0 && filteredActivities === 0;

    if (!isSupplyError && !isEmptyActivities && !isEmptyFromFiltered) {
        return null;
    }

    return <NoResultsErrorPage cityName={cityName} isEmptyFromFiltered={isEmptyFromFiltered} selectedFilters={selectedFilters} />;
};
SearchSupplyError.displayName = 'SearchSupplyError';

export default SearchSupplyError;
